import React from 'react';
import {
  FDLozenge, FDTableCell,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const getLozengeColorFromValue = (value) => {
  switch (value) {
    case 'Awaiting Allocation':
    case 'No model':
      return 'warning';
    default:
      return 'info';
  }
};

export const SelectedModelLozenge = ({ value }) => {
  const color = getLozengeColorFromValue(value);

  return (
    <FDTableCell>
      {value && <FDLozenge label={value} color={color} /> }
    </FDTableCell>
  );
};

SelectedModelLozenge.propTypes = {
  value: PropTypes.string.isRequired,
};
